module.exports = __webpack_public_path__ + "static/mq-61a53cf5d503e731ff4136c9d1dbdee4.svg";